import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';

import { Page } from '../../components';
import { useStyles } from './styles.js';

class Complete extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { className, classes, history } = this.props;

    return (
      <Page
        title={'Waste Management Complete'}
        className={classes.completeRoot}
      >
        <Typography className={classes.completeHeader}>
          {this.props.questions_answered == 'Zero'
            ? `That's a whiff! You did not unlock any new roster spots.`
            : `Congrats! You unlocked ${this.props.questions_answered.toLowerCase()} roster ${
                this.props.questions_answered == 'One' ? `spot` : 'spots'
              }.`}
        </Typography>
        <Typography className={classes.completeText}>
          {this.props.questions_answered == 'Zero'
            ? `This week was a tough one, but Charley is still on your team when the draft opens on Feb 7th.`
            : ` You can now add ${this.props.questions_answered.toLowerCase()} more ${
                this.props.questions_answered == 'One' ? `player` : 'players'
              } to join Charley Hoffman on your team
         when the draft opens on Feb 7th.`}
        </Typography>
        <Typography className={classes.completeText}>
          Reminder, your team must consist of at least four total players to
          participate in the WMPO Challenge.
        </Typography>
        <Button
          className={classes.completeButton}
          onClick={() => this.props.returnHome()}
        >
          Return Home
        </Button>
      </Page>
    );
  }
}

Complete.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(Complete);
